import { jsx as e } from "react/jsx-runtime";
import { e as m, n } from "../../../pointsGraph-DTJju-rA.js";
const i = ({ displayName: t, contactId: r, onClick: a, selected: o }) => /* @__PURE__ */ e(
  m,
  {
    itemType: "student",
    title: t,
    avatar: /* @__PURE__ */ e(n, { contactId: r, contactFullName: t }),
    selected: o,
    onClick: a
  }
);
export {
  i as StudentItem
};
//# sourceMappingURL=student.js.map
